import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { userInRoles } from "../services/authService";
import { Typography } from "@material-ui/core";

class PrivateRoute extends Component {
  render() {
    const {
      user,
      userIsLoading,
      component: Component,
      requiredRoles
    } = this.props;

    return userIsLoading ? (
      <div>loading...</div>
    ) : userInRoles(user, requiredRoles) ? (
      <Component />
    ) : (
      <div>
        <Typography variant="h4" gutterBottom component="h2">
          Unauthorized
        </Typography>
      </div>
    );
  }
}

PrivateRoute.propTypes = {
  user: PropTypes.object.isRequired,
  requiredRoles: PropTypes.array.isRequired,
  userIsLoading: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user.user,
    userIsLoading: state.user.userIsLoading
  };
}

export default connect(mapStateToProps)(PrivateRoute);
